/**
 * codmonNotificationBanner
 * @example
 * <codmon-notification-banner
 *   variant="info|warning|error"
 *   notification-title="タイトル"
 *   button-label="ボタンラベル"
 *   button-click="onClick()"
 *   button-leading-icon-name="icon_name"
 *   button-trailing-icon-name="icon_name"
 * >
 *   バナーの説明や補足テキスト
 * </codmon-notification-banner>
 *
 * // タイトルにリンクを設定したい場合
 * <codmon-notification-banner
 *   variant="info"
 *   notification-title="タイトルにリンク設定"
 *   notification-title-link="https://hoge"
 * ></codmon-notification-banner>
 *
 * // タイトルから画面内の state へ遷移させたい場合
 * <codmon-notification-banner
 *   variant="warning"
 *   notification-title="タイトルから画面内へ遷移"
 *   notification-title-sref="profile.password"
 * ></codmon-notification-banner>
 *
 * @param {string} variant バナーの種類（info, warning, error）
 * @param {string} notificationTitle バナーのタイトル
 * @param {string=} notificationTitleLink タイトルのリンク先URL（省略可。新しいタブで開く）
 * @param {string=} notificationTitleSref タイトルの遷移先 state 名（省略可。同じタブで画面内遷移する。notificationTitleLink と併用しない）
 * @param {string=} buttonLabel ボタンのラベル（省略可）
 * @param {function=} buttonClick ボタン押下時のコールバック関数（省略可）
 * @param {string=} buttonLeadingIconName ボタン左側のアイコン名（省略可）
 * @param {string=} buttonTrailingIconName ボタン右側のアイコン名（省略可）
 * @transclude バナー本文（説明文など）を挿入可能
 */
angular.module('inspinia').directive('codmonNotificationBanner', function () {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      variant: '@',
      notificationTitle: '@',
      notificationTitleLink: '@?',
      notificationTitleSref: '@?',
      buttonLabel: '@?',
      buttonClick: '&?',
      buttonLeadingIconName: '@?',
      buttonTrailingIconName: '@?',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_notification_banner.html?${new Date().getTime()}`,
    link: function (scope) {
      // ベースクラス
      scope.baseClass = 'base';

      // variantごとのクラス
      scope.variantClass = function () {
        if (scope.variant === 'info') return 'variant-info';
        if (scope.variant === 'warning') return 'variant-warning';
        if (scope.variant === 'error') return 'variant-error';
        return '';
      };

      // ヘッダーのクラス
      scope.headerBannerClass = 'header-banner';

      // アイコンクラス
      scope.iconClass = 'notification-icon';
      scope.iconTypeClass = function () {
        if (scope.variant === 'info') return 'notification-icon-info';
        if (scope.variant === 'warning') return 'notification-icon-warning';
        if (scope.variant === 'error') return 'notification-icon-error';
        return '';
      };

      // タイトルクラス
      scope.titleClass = 'notification-title';
      scope.titleLinkClass = 'notification-title-link';

      // trailingアイコンクラス
      scope.trailingIconClass = 'trailing-icon';

      // descriptionクラス
      scope.descriptionClass = 'notification-description';

      scope.iconName = '';
      if (scope.variant === 'info') scope.iconName = 'info_fill';
      if (scope.variant === 'warning') scope.iconName = 'warning_fill';
      if (scope.variant === 'error') scope.iconName = 'error_fill';
    },
  };
});
